/* kh-sticky-atc v2 — sticky add-to-cart bar (MPS Buy Me replacement).
   Replicates the MPS widget behavior as configured on this store: appears
   after scrolling past the product form, per-option variant selects, price +
   compare + "NN% SAVE" badge, Loox stars, title gains the variant name.
   ATC proxies the theme's real submit button so the cart-drawer intercept
   and pixels fire identically to the main button. ES5. */
(function () {
  'use strict';
  if (window.__khsaInit) return;
  window.__khsaInit = true;

  var cfg = window.khsaConfig;
  var bar = document.getElementById('khStickyAtc');
  if (!cfg || !bar) return;

  /* ---------- main product form (scope to the main section, not app/installment forms) ---------- */
  var mainForm =
    document.querySelector('[id$="__main"] form[data-type="add-to-cart-form"]') ||
    document.querySelector('form[data-type="add-to-cart-form"]');
  if (!mainForm) return; /* unusual template (e.g. shogun custom) — stay hidden */

  var mainBtn = mainForm.querySelector('.product-form__submit') ||
                mainForm.querySelector('[type="submit"], [name="add"]');
  var idInput = mainForm.querySelector('input[name="id"], select[name="id"]');
  if (!mainBtn || !idInput) return;

  var mainSection = mainForm.closest('.shopify-section') || document;
  var picker = mainSection.querySelector('variant-radios, variant-selects');

  var btn = document.getElementById('khsaBtn');
  var btnLabel = document.getElementById('khsaBtnLabel');
  var titleEl = document.getElementById('khsaTitle');
  var priceEl = document.getElementById('khsaPrice');
  var compareEl = document.getElementById('khsaCompare');
  var discountEl = document.getElementById('khsaDiscount');
  var discountText = document.getElementById('khsaDiscountText');
  var starsSlot = document.getElementById('khsaStars');
  var selects = [].slice.call(bar.querySelectorAll('select[data-khsa-option]'));

  function findVariantById(id) {
    id = String(id);
    for (var i = 0; i < cfg.variants.length; i++) {
      if (String(cfg.variants[i].id) === id) return cfg.variants[i];
    }
    return null;
  }

  function findVariantByOptions(opts) {
    for (var i = 0; i < cfg.variants.length; i++) {
      var v = cfg.variants[i];
      var match = true;
      for (var j = 0; j < opts.length; j++) {
        if (v.options[j] !== opts[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function selectedOptions() {
    var opts = [];
    for (var i = 0; i < selects.length; i++) opts.push(selects[i].value);
    return opts;
  }

  /* ---------- render bar state from a variant (or null = unavailable combo) ---------- */
  function render(v) {
    if (!v) {
      btn.disabled = true;
      btnLabel.textContent = cfg.unavailableLabel || cfg.soldOutLabel;
      if (discountEl) { discountEl.hidden = true; }
      return;
    }
    if (priceEl) priceEl.textContent = v.price;
    if (compareEl) {
      if (v.compare) { compareEl.textContent = v.compare; compareEl.hidden = false; }
      else { compareEl.textContent = ''; compareEl.hidden = true; }
    }
    if (discountEl && discountText) {
      if (v.pct > 0) {
        discountText.textContent = (cfg.discountTemplate || '{{discount}} SAVE')
          .replace('{{discount}}', v.pct + '%');
        discountEl.hidden = false;
      } else {
        discountEl.hidden = true;
      }
    }
    /* image stays the product hero image — MPS never swaps it per variant */
    if (titleEl && cfg.showVariantInTitle && v.title && v.title !== 'Default Title') {
      titleEl.textContent = cfg.baseTitle + ' - ' + v.title;
    }
    for (var i = 0; i < selects.length; i++) {
      if (v.options[i] != null && selects[i].value !== v.options[i]) {
        selects[i].value = v.options[i];
      }
    }
    btn.disabled = !v.available;
    btnLabel.textContent = v.available ? cfg.addLabel : cfg.soldOutLabel;
  }

  /* ---------- show / hide: fade in once the real ATC button is scrolled past ---------- */
  var starsCloned = false;
  function updateVisibility() {
    var rect = mainBtn.getBoundingClientRect();
    /* hidden buttons report a zero rect — never show the bar off a zero rect */
    var gone = (rect.width > 0 || rect.height > 0) && rect.bottom < 0;
    if (gone && !starsCloned) cloneStars();
    bar.classList.toggle('is-visible', gone);
    bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
  }
  /* time-throttled, NOT requestAnimationFrame: Meta in-app webviews (the main
     traffic source) can suspend rAF, which would freeze the bar's visibility */
  var pending = false;
  function requestUpdate() {
    if (pending) return;
    pending = true;
    window.setTimeout(function () { pending = false; updateVisibility(); }, 100);
  }
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  updateVisibility();

  /* Loox stars (lazyloaded by the app) — clone on first show, like MPS's
     company_selector '.loox-rating:first' */
  function cloneStars() {
    starsCloned = true;
    if (!starsSlot) return;
    var stars = document.querySelector('.loox-rating');
    if (stars) starsSlot.appendChild(stars.cloneNode(true));
  }

  /* ---------- main picker -> bar (Dawn updates input[name=id] synchronously) ---------- */
  document.addEventListener('change', function (e) {
    if (picker && (picker === e.target || picker.contains(e.target))) {
      window.setTimeout(function () { render(findVariantById(idInput.value)); }, 0);
    }
  });

  /* ---------- bar selects -> main picker (drive Dawn so price/media/URL stay in sync) ---------- */
  function onBarSelectChange() {
    var v = findVariantByOptions(selectedOptions());
    if (!v) { render(null); return; }
    if (picker) {
      for (var i = 0; i < v.options.length; i++) {
        var val = v.options[i];
        var fieldsets = picker.querySelectorAll('fieldset');
        if (fieldsets.length) {
          var radios = fieldsets[i] ? fieldsets[i].querySelectorAll('input[type="radio"]') : [];
          for (var r = 0; r < radios.length; r++) {
            if (radios[r].value === val) { radios[r].checked = true; break; }
          }
        } else {
          var pickerSelects = picker.querySelectorAll('select');
          if (pickerSelects[i]) pickerSelects[i].value = val;
        }
      }
      picker.dispatchEvent(new Event('change', { bubbles: true }));
      window.setTimeout(function () { render(findVariantById(idInput.value) || v); }, 0);
    } else {
      idInput.value = String(v.id);
      idInput.disabled = false;
      render(v);
    }
  }
  for (var s = 0; s < selects.length; s++) {
    selects[s].addEventListener('change', onBarSelectChange);
  }

  /* ---------- add to cart: proxy the real form button ---------- */
  var adding = false;
  btn.addEventListener('click', function () {
    if (adding || btn.disabled) return;
    adding = true;
    btn.classList.add('is-adding');

    /* Dawn's product-form.js normally un-disables the id input; do it ourselves
       in case the user beats the lazyloaded theme scripts */
    idInput.disabled = false;

    /* real click → capture-phase drawer intercept / Dawn handler / native submit
       all behave exactly as if the user pressed the main button */
    mainBtn.click();

    window.setTimeout(function () {
      adding = false;
      btn.classList.remove('is-adding');
    }, 1200);
  });
})();
